import Showdown from 'showdown';
import styled from 'styled-components';

import Typo from '@/components/Typography/Typo';
import { MessageTextStyle } from '@/entities/hey-syncly';
import useColor from '@/hooks/domain/useColor';

const converter = new Showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
  simpleLineBreaks: true,
  disableForced4SpacesIndentedSublists: true,
});

export type DocumentRow = {
  columnKey: string;
  type: string;
  required?: boolean;
  desc: string;
};

type Props = {
  rows: DocumentRow[];
};

const FieldTable = (props: Props) => {
  const color = useColor();
  return (
    <Style>
      <table cellSpacing="0">
        <thead>
          <tr>
            <th>
              <Typo type="body3">Field name</Typo>
            </th>
            <th>
              <Typo type="body3">Type</Typo>
            </th>
            <th>
              <Typo type="body3">Required</Typo>
            </th>
            <th>
              <Typo type="body3">Description</Typo>
            </th>
          </tr>
        </thead>
        <colgroup>
          <col width="140px"></col>
          <col width="100px"></col>
          <col width="80px"></col>
          <col width="auto"></col>
        </colgroup>
        <tbody>
          {props.rows.map((row) => (
            <tr key={row.columnKey}>
              <td>
                <Typo type="body2" weight="m" color={color.gray800}>
                  {row.columnKey}
                </Typo>
              </td>
              <td>
                <Typo type="body2">{row.type}</Typo>
              </td>
              <td>
                {row.required ? (
                  <Typo type="body2" color={color.primary100} weight="sb">
                    Required
                  </Typo>
                ) : (
                  <Typo type="body2">optional</Typo>
                )}
              </td>
              <td>
                <MessageTextStyle
                  className="p-2 rounded-3xl"
                  dangerouslySetInnerHTML={{
                    __html: converter.makeHtml(row.desc),
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Style>
  );
};

const Style = styled.div`
  table {
    width: 100%;
    tr {
      th {
        text-align: left;
        padding: 16px 10px;
        border: none;
        border-top: 1px solid ${(props) => props.theme.colors.gray300};
        border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
        color: ${(props) => props.theme.colors.gray600};
        font-weight: 400;
        background-color: ${(props) => props.theme.colors.gray200};
      }
      td {
        text-align: left;
        padding: 16px 10px;
        border: none;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
        color: ${(props) => props.theme.colors.gray700};
      }
    }
  }
`;

export default FieldTable;
